import { LocalizedSkill } from "../LocalizedGroups";
import { Chip } from "@mui/material";

type Props = {
  localizedSkills: LocalizedSkill[];
  onDelete?: (skillId: string) => void;
};

const Chips = ({ localizedSkills, onDelete }: Props) => (
  <>
    {localizedSkills.map((skill) => (
      <Chip
        onDelete={onDelete && (() => onDelete(skill.id))}
        sx={{
          marginRight: 1,
          backgroundColor: "#A273E1",
          color: "#FFFFFF",
          fontWeight: 600,
          fontSize: 14,
          height: 24,
          "& .MuiChip-deleteIcon": {
            color: "#FFFFFF70",
          },
          "& .MuiSvgIcon-root": {
            width: "0.8em",
            height: "0.8em",
          },
        }}
        key={skill.name + "-" + skill.id}
        label={skill.name}
        variant="filled"
      />
    ))}
  </>
);

export default Chips;
